import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import Select from 'react-select'

const statusOptions = [
  { label: 'Pending', value: 'pending' },
  { label: 'Paid', value: 'paid' },
  { label: 'Penalty', value: 'penalty' },
  { label: 'Partially', value: 'partially' }
]

const UpdatePaymentStatus = ({ toggle, setIsRefresh }) => {
  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    // resolver: yupResolver(newRegionAdminSchema)
    // defaultValues: {}
  })
  const onSubmit = (data) => {
    setIsRefresh(false)
    console.log('data :>> ', data)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <div className="form-group input_text">
            <label>
              Status
              <span className="text-danger"> *</span>
            </label>
            <Controller
              name="status"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  className={`react-selectcomponent form-control ${errors?.status ? 'error-input' : ''}`}
                  getOptionLabel={(option) => `${option.label}`}
                  options={statusOptions || []}
                  isSearchable={true}
                  isClearable
                  placeholder={`Select Status`}
                  classNamePrefix="select_kanakku"
                />
              )}
            />
            <small>{errors?.status?.message || errors?.status?.message}</small>
          </div>
        </div>
      </div>
      <div className="multi_btn_div">
        <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
          Cancel
        </button>
        <button type="submit" className="btn btn-primary common-field-btn w-100">
          {`Save`}
        </button>
      </div>
    </form>
  )
}

export default UpdatePaymentStatus
